import React from 'react';
import '../chart/LiquiditySummaryChart.scss';
import './LiquiditySummaryChartIllustration.scss';
import classNames from 'classnames';

export interface LiquiditySummaryChartIllustrationProps {
    dimVol?: boolean;
    dimRem?: boolean;
}

export function LiquiditySummaryChartIllustration(
    props: LiquiditySummaryChartIllustrationProps
) {
    const { dimVol, dimRem } = props;

    return (
        <div
            className={classNames(
                'LiquiditySummaryChart',
                'LiquiditySummaryChartIllustration',
                dimVol && 'dim-vol',
                dimRem && 'dim-rem'
            )}
        >
            <div className=" Chart">
                <div className="cartesian-chart">
                    <div className="svg-plot-area plot-area">
                        <svg viewBox="0 0 252 84">
                            <g className="multi">
                                <g>
                                    <g className="multi">
                                        <g>
                                            <g
                                                className="bar horizontal liquidity-summary-block today open section-open"
                                                transform="translate(0, 50.32)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h0v20h0Z"></path>
                                            </g>
                                            <g
                                                className="bar horizontal liquidity-summary-block hist open section-open"
                                                transform="translate(10.537190082644628, 16.720000000000006)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h-10.537190082644628v20h10.537190082644628Z"></path>
                                            </g>
                                        </g>
                                    </g>
                                    <g className="multi">
                                        <g>
                                            <g
                                                className="bar horizontal liquidity-summary-block today volume section-open"
                                                transform="translate(105.37190082644628, 50.32)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h-105.37190082644628v20h105.37190082644628Z"></path>
                                                <rect
                                                    x="-2"
                                                    y="-10"
                                                    width="2"
                                                    height="26"
                                                    className="marker-line"
                                                ></rect>
                                                <rect
                                                    y="16"
                                                    height="13"
                                                    className="marker-rect"
                                                    x="-11.498779296875"
                                                    width="22.99755859375"
                                                ></rect>
                                                <text
                                                    y="26.5"
                                                    // eslint-disable-next-line react/no-unknown-property
                                                    align-baseline="middle"
                                                    className="marker-text"
                                                    x="-9.498779296875"
                                                >
                                                    Now
                                                </text>
                                            </g>
                                            <g
                                                className="bar horizontal liquidity-summary-block hist volume section-open"
                                                transform="translate(126.44628099173553, 16.720000000000006)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h-115.9090909090909v20h115.9090909090909Z"></path>
                                                <rect
                                                    x="-2"
                                                    y="-10"
                                                    width="2"
                                                    height="20"
                                                    className="marker-line"
                                                ></rect>
                                            </g>
                                        </g>
                                    </g>
                                    <g className="multi">
                                        <g>
                                            <g
                                                className="bar horizontal liquidity-summary-block today remainingVolume section-close"
                                                transform="translate(189.66942148760333, 50.32)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h-84.29752066115705v20h84.29752066115705Z"></path>
                                            </g>
                                            <g
                                                className="bar horizontal liquidity-summary-block hist remainingVolume section-close"
                                                transform="translate(200.20661157024796, 16.720000000000006)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h-73.76033057851242v20h73.76033057851242Z"></path>
                                            </g>
                                        </g>
                                    </g>
                                    <g className="multi">
                                        <g>
                                            <g
                                                className="bar horizontal liquidity-summary-block today close section-close"
                                                transform="translate(189.66942148760333, 50.32)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h0v20h0Z"></path>
                                                <rect
                                                    x="-2"
                                                    y="-10"
                                                    width="2"
                                                    height="26"
                                                    className="marker-line"
                                                ></rect>
                                                <rect
                                                    y="16"
                                                    height="13"
                                                    className="marker-rect"
                                                    x="-14.254150390625"
                                                    width="28.50830078125"
                                                ></rect>
                                                <text
                                                    y="26.5"
                                                    // eslint-disable-next-line react/no-unknown-property
                                                    align-baseline="middle"
                                                    className="marker-text"
                                                    x="-12.254150390625"
                                                >
                                                    Close
                                                </text>
                                            </g>
                                            <g
                                                className="bar horizontal liquidity-summary-block hist close section-close"
                                                transform="translate(231.81818181818184, 16.720000000000006)"
                                                fill="#999"
                                            >
                                                <path d="M0,-10h-31.611570247933884v20h31.611570247933884Z"></path>
                                                <rect
                                                    x="-2"
                                                    y="-10"
                                                    width="2"
                                                    height="20"
                                                    className="marker-line"
                                                ></rect>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g className="multi">
                                <g>
                                    <g className="multi">
                                        <g>
                                            <path
                                                className="line line-movement open"
                                                fill="none"
                                                stroke="#000"
                                                d="M0,40.32L10.537190082644628,26.72000000000001"
                                                transform="translate(-1,0)"
                                            ></path>
                                        </g>
                                    </g>
                                    <g className="multi">
                                        <g>
                                            <path
                                                className="line line-movement volume"
                                                fill="none"
                                                stroke="#000"
                                                d="M105.37190082644628,40.32L126.44628099173553,26.72000000000001"
                                                transform="translate(-1,0)"
                                            ></path>
                                        </g>
                                    </g>
                                    <g className="multi">
                                        <g>
                                            <path
                                                className="line line-movement remainingVolume"
                                                fill="none"
                                                stroke="#000"
                                                d="M189.66942148760333,40.32L200.20661157024796,26.72000000000001"
                                                transform="translate(-1,0)"
                                            ></path>
                                        </g>
                                    </g>
                                    <g className="multi">
                                        <g>
                                            <path
                                                className="line line-movement close"
                                                fill="none"
                                                stroke="#000"
                                                d="M189.66942148760333,40.32L231.81818181818184,26.72000000000001"
                                                transform="translate(-1,0)"
                                            ></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}
